import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-category',
  templateUrl: './category.component.html',
  styleUrls: ['./category.component.scss']
})
export class CategoryComponent implements OnInit {

  category1 : any;
  category: Object;

  @Output() onDatePicked: EventEmitter<any> = new EventEmitter<any>();
  categoryName: any;
  display: boolean;

  ngOnInit() {

    if (window.innerWidth < 1281) {
      this.display = false;
    }else{
      this.display=true
    }

  }
  categoryList: any;
  information: any[];

  automaticClose = true;

  constructor(
    private http: HttpClient,
    private commonService: CommonService,
    private route:ActivatedRoute,
    private router:Router,
  ) {
    this.route.queryParams.subscribe(params => {
      this.categoryName=JSON.parse(params['subcategory'])['categoryName'];
      this.categoryList =JSON.parse(params['subcategory'])['subcategories'];

  });
  }



  productList(menu,length){

     

      this.commonService.selectedCategory(menu.categoryName,menu.categoryId,menu);


  }

  toggleSection(i) {
    if(this.categoryList[i].subcategories.length >0){
      this.categoryList[i].open = !this.categoryList[i].open;
    }

  }
  toggleItem(i, j) {
    if(this.categoryList[i].subcategories[j].subcategories.length >0){
      this.categoryList[i].subcategories[j].open = !this.categoryList[i].subcategories[j].open;
    }
  }

  search(){
    this.router.navigate(['/search'])
  }




}
